// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","component":"ContentComponentSection_component__mj4Z9"};